import { Bank } from '../types/Bank';
import { apiGet, apiPatch } from './client';

interface BatchRequest {
  added: Bank[];
  modified: Bank[];
  deleted: number[];
}

export function getBanks(): Promise<Bank[]> {
  return apiGet<Bank[]>('/api/banks');
}

export function saveBatchBanks(
  added: Bank[],
  modified: Bank[],
  deletedIds: number[],
): Promise<Bank[]> {
  return apiPatch<BatchRequest, Bank[]>('/api/banks/batch', {
    added,
    modified,
    deleted: deletedIds,
  });
}
